import { render } from "./levelMessage.vue?vue&type=template&id=a5a8b974&scoped=true"
import script from "./levelMessage.vue?vue&type=script&lang=js"
export * from "./levelMessage.vue?vue&type=script&lang=js"

import "./levelMessage.vue?vue&type=style&index=0&id=a5a8b974&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a8b974"]])

export default __exports__